import MediaImageLoader from '@/common/components/mediaImage/MediaImageLoader';

const StudioCardImage = ({
	src,
	alt,
	webpSrc,
	priority = false,
	loading = 'lazy',
	objectPosition = 'center top',
}) => (
	<MediaImageLoader
		src={src}
		alt={alt}
		webpSrc={webpSrc}
		objectPosition={objectPosition}
		priority={priority}
		loading={loading}
	/>
);

export default StudioCardImage;
